import { useMemo } from "react";
import { PageTitle } from "../../../_metronic/layout/core"
const Unauthorized = () => {
    const iconStyle = useMemo(() => ({ color: '#992936'}), []);
    return (
        <>
            <PageTitle>Área no autorizada</PageTitle>
            <div class="alert alert-danger d-flex" role="alert">
                <div className="me-4">
                    <i class="fi fi-rr-hand-dots fs-1"style={iconStyle}></i>
                </div>
                <div className="w-100">
                    <h4 class="alert-heading">  Area no autorizada!</h4>
                    <p>Su usuario no tiene permisos para visualizar esta sección.</p>
                    <hr />
                    <p class="mb-0">Si usted está seguro que esto es un error, por favor contactarse con el administrador.</p>
                </div>
            </div>
        </>
    )
}
export { Unauthorized }